module.exports = __webpack_public_path__ + "loader.da08a58139765bbc55dc.svg";


//////////////////
// WEBPACK FOOTER
// /Users/kamil/Projekty/greinprofit/src/assets/img/loader.svg
// module id = ../../../../../src/assets/img/loader.svg
// module chunks = 2